<div class="kpi-grid">
    <!-- Single points: Cloud Users / Organizations / App Instances / MRR -->
    @for (card of cards; track card.title) {
        <r1-metrics-single-datapoint [card]="card" [readAs]="card.title" />
    }
</div>
@if (isLoading$ | async) {
    <r1-loading-spinner [loadingMessages]="loadingMessages$ | async" />
}
